import { useContext } from "react";
import {
  UpgradeModalContextType,
  UpgradeModalContext,
} from "@via/context/upgrade-modal-context";

export const useUpgradeModal = (): UpgradeModalContextType => {
  const context = useContext(UpgradeModalContext);
  if (context === undefined) {
    throw new Error(
      "useUpgradeModal must be used within an UpgradeModalProvider"
    );
  }
  return context;
};
